export default "__VITE_ASSET__Bpkcu7vm__"